var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreydot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "54220F91-7B08-4442-A8B9-977DF8EEAFBwe0@0.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navic-GoSend---Phase-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.5b-Details---Pickup-package",
    transform: "translate(-18.000000, -605.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Status",
    transform: "translate(0.000000, 399.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List",
    transform: "translate(18.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ongoing",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#CACCCF",
    fill: "#CACCCF",
    cx: 10,
    cy: 10,
    r: 6
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreydot);
export default __webpack_public_path__ + "static/media/greydot.9f361976a6700c7fe53c23872618d620.svg";
export { ForwardRef as ReactComponent };